<template>
  <div v-if="show" class="modal">
    <div @click="closeModal" class="modal__close">
      <svg
        class="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        ></path>
      </svg>
    </div>
    <form class="form" @submit.prevent="pay">
      <h2>Step 1 of 2</h2>
      <h3 class="modal__title">Enter your email and name</h3>
      <div>
        <label for="">First name</label>
        <input
          ref="name"
          class="form__input"
          placeholder="First name"
          type="text"
          v-model="data.firstName"
          required
        />
      </div>
      <div>
        <label for="">Last name</label>
        <input
          ref="name"
          class="form__input"
          placeholder="Last name"
          type="text"
          v-model="data.lastName"
          required
        />
      </div>
      <div>
        <label for="">Email</label>
        <input
          class="form__input"
          placeholder="Your email"
          type="email"
          v-model="data.email"
          required
        />
      </div>
      <div>
        <input @submit="pay" class="button" type="submit" value="Submit" />
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    type: Number,
    price: Number,
    period: Number,
    product: String
  },
  data() {
    return {
      data: {
        email: '',
        firstName: '',
        lastName: '',
        period: 1
      },
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    pay() {
      this.$store
        .dispatch('pay', { ...this.data, type: this.type, price: this.price, period: this.period, product: this.product })
        .then((finalLink) => {
          window.open(finalLink)
          this.$store.dispatch('logUser', {
            ...this.data,
            from: this.$route.query.from,
          })
          this.$store.dispatch('sendEmail', this.data)
        })
    },
  },
}
</script>

<style lang="scss">
.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px;
  max-width: 300px;
  width: 100%;
  z-index: 100000;

  &__title {
    margin-top: 0;
  }

  &__close {
    width: 20px;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }

  .form {
    margin-top: 20px;
    // text-align: center;
    &__input {
      width: 100%;
      border: 1px solid rgb(95, 95, 95);
      padding: 10px;
      margin-bottom: 20px;
    }
  }
}
</style>
